import { BookOpen, ShieldCheck, Trophy, Flag, Users, Ban } from "lucide-react";
import { Link } from "react-router-dom";

const RULES = [
  { icon: Users, title: "Eligibility", text: "A free GamePlat account is required to compete when registration opens. One account per player — smurfing or shared accounts are not allowed." },
  { icon: Flag, title: "Waitlist and registration", text: "The Balatro Community Challenge is December 12, 2026. Join the waitlist now. We email waitlist players when registration opens. Waitlist size stays private. Spots are first-come, first-served up to 64 seats." },
  { icon: Trophy, title: "Match results", text: "Play on an official copy of Balatro. Submit your score with a screenshot when the event is live. Wins hit the leaderboard (3 points) only after an admin verifies them." },
  { icon: ShieldCheck, title: "Fair play", text: "Standard decks. No mods, trainers, or unofficial clients. Cheating in the contest means disqualification. Yorick is coaching, not a score drop box." },
  { icon: Ban, title: "Conduct", text: "Harassment, hate speech, and toxic behavior are not tolerated on GamePlat. Discord is not connected yet — use Support for reports." },
  { icon: BookOpen, title: "Disputes", text: "Report score disputes through Support within 24 hours of the event. Admin decisions are final." },
];

export default function Rules() {
  return (
    <div className="mx-auto max-w-4xl px-5 md:px-8 py-12 md:py-16">
      <div className="flex items-center gap-3 mb-2">
        <BookOpen className="text-gp-blue" size={26} />
        <h1 className="font-unbounded font-black tracking-tighter text-4xl uppercase">Rules</h1>
      </div>
      <p className="text-white/60 mb-10">Ground rules for GamePlat events. Play smart, play fair. Next contest: December 12, 2026.</p>

      <div className="grid sm:grid-cols-2 gap-5" data-testid="rules-list">
        {RULES.map((r) => {
          const Icon = r.icon;
          return (
            <div key={r.title} className="glass rounded-2xl p-6">
              <span className="grid place-items-center h-11 w-11 rounded-xl bg-gp-blue/15 text-gp-blue"><Icon size={20} /></span>
              <h3 className="font-unbounded font-bold text-lg mt-4">{r.title}</h3>
              <p className="text-white/70 mt-2 text-sm leading-relaxed">{r.text}</p>
            </div>
          );
        })}
      </div>
      <p className="mt-8 text-sm text-white/50">
        Ready to compete? <Link to="/tournaments" className="text-gp-blue hover:underline">Join the waitlist</Link>
        {" "}or <Link to="/balatro/beginner-guide" className="text-gp-blue hover:underline">read the beginner guide</Link>.
      </p>
    </div>
  );
}
